import { render, staticRenderFns } from "./FabricView.vue?vue&type=template&id=0dfc5dfc&scoped=true"
import script from "./FabricView.vue?vue&type=script&lang=js"
export * from "./FabricView.vue?vue&type=script&lang=js"
import style0 from "./FabricView.vue?vue&type=style&index=0&id=0dfc5dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc5dfc",
  null
  
)

export default component.exports